import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>We have reviewed all current authorizations for this patient requested by you and any other prescribers.</p>
				<p>The total number of calories per day currently authorized for this patient is:  {this.props.data.TotalCaloriesPerDay}.</p>
				
				<div className="button" onClick={()=>this.props.navigate('P3')}>Continue</div>
			</div>
		);
	}
}